import { render, staticRenderFns } from "./PodList.vue?vue&type=template&id=0558804a&scoped=true&"
import script from "./PodList.vue?vue&type=script&lang=ts&"
export * from "./PodList.vue?vue&type=script&lang=ts&"
import style0 from "./PodList.vue?vue&type=style&index=0&id=0558804a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0558804a",
  null
  
)

export default component.exports